module.exports = __webpack_public_path__ + "static/media/buttered.84598310.png";